import HTTPService from '@/api/http/HTTPService'

export default {
  getAll: (siteSlug: string, brandSlug: string) => HTTPService.get(`site/${siteSlug}/brand/${brandSlug}/model`),
  getOne: (siteSlug: string, brandSlug: string, modelSlug: string) => HTTPService.get(`site/${siteSlug}/brand/${brandSlug}/model/${modelSlug}`),
  select: (siteSlug: string, brandSlug: string, modelSlug: string) => HTTPService.post(`site/${siteSlug}/brand/${brandSlug}/model/${modelSlug}/select`),
  unselect: (siteSlug: string, brandSlug: string, modelSlug: string) => HTTPService.post(`site/${siteSlug}/brand/${brandSlug}/model/${modelSlug}/unselect`),
}
